
// UploadDocumentsPage.jsx
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthUser from "../services/AuthUser";
import StepProgress from '../view/New/StepProgress';


const UploadDocumentsPage = () => {
    const { http, token } = AuthUser();
    const navigate = useNavigate();


    const [formData, setFormData] = useState({});
    const [files, setFiles] = useState([]);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [error, setError] = useState("");
    const currentStep = 2;

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem('bookingData'));
        if (!stored) return navigate('/');
        setFormData(stored);



    }, []);

    const generateUserId = (data) => {
        // Extract and clean name part (first 3 letters, only alphabets, uppercase, pad if short)
        let namePart = (data.name || "")
            .replace(/[^a-zA-Z]/g, "")
            .substring(0, 3)
            .toUpperCase()
            .padEnd(3, 'X');

        // Extract and clean email part (first 3 letters before '@', only alphabets)
        let emailName = (data.email || "").split('@')[0];
        let emailPart = emailName
            .replace(/[^a-zA-Z]/g, "")
            .substring(0, 3)
            .toUpperCase()
            .padEnd(3, 'X');

        // Use last 4 digits of phone number
        let phoneDigits = (data.phone_number || "").replace(/\D/g, "");
        let phonePart = phoneDigits.slice(-4).padStart(4, '0'); // Fallback if phone number is too short

        return `${namePart}${emailPart}${phonePart}`; // Example: PRACHI3210
    };


    useEffect(() => {
        const agent = JSON.parse(localStorage.getItem("agent"));
        const user = JSON.parse(localStorage.getItem("user"));
        const bookingData = JSON.parse(localStorage.getItem("bookingData"));
        const userId = generateUserId(bookingData);

        if (agent && agent.email) {
            setEmail(bookingData.email);
            setName(userId || "Agent");
        } else if (user && user.email) {
            setEmail(user.email);
            setName(user.user_id || "User");
        } else {
            setError("User not found.");
        }
    }, []);

    const handleFileChange = (e) => {
        setFiles(Array.from(e.target.files));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !email || files.length === 0) {
            setError("Please select at least one file.");
            return;
        }

        const formData = new FormData();
        formData.append("doc_id", name);
        formData.append("email", email);
        files.forEach((file) => {
            formData.append("documents[]", file);
        });

        try {
            const response = await http.post("/upload-files", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.status === 200) {
                setSuccessMessage(response.data.message);
                setFiles([]);
                // alert("File upload successfully!");

                // handleFileChange(); // optional
                localStorage.removeItem('bookingData');
                navigate("/success", { state: { uploaded: true } });
            }
        } catch (error) {
            setError("File upload failed! Please try again.");
            alert("File upload failed! Please try again.");
            console.error(error);
        }

    };





    return (

        <div className="hero-area10 header-background min-vh-100">
            <div className="container py-4 mt-4">
                {/* Progress Steps */}
                <div className=' d-flex justify-content-center align-items-center mb-5 position-relative'>
                    <img className='process-img' src="assets/new/process-02.png" alt="" srcset="" />
                </div>

                {/* Main Section */}
                <div className="row m-4 justify-content-center">
                    {/* Left Side Info */}
                    <div className="col-md-6 mb-4">

                        <h1
                            className="sk-text-color mb-3 check-out-head"

                        >
                            Upload Documents
                        </h1>


                        <div className="mt-4">
                            <h5>User Information:</h5>
                            <p><strong>Name:</strong> {formData.user_name || formData.name}</p>
                            <p><strong>Email:</strong> {formData.user_email || formData.user_email_address || formData.email}</p>
                            <p><strong>Contact:</strong> {
                                formData.user_contact_number ||
                                formData.user_phone_number ||
                                formData.phone_number ||
                                formData.user_contact ||
                                formData.user_phone
                            }</p>

                            {/* <p><strong>City:</strong> {formData.city}</p> */}
                        </div>
                    </div>

                    {/* Right Side Summary */}
                    <div
                        className="col-md-5 p-4 text-white"
                        style={{
                            backgroundColor: '#00254d',
                            border: '2px solid #00a6ff',
                            borderRadius: '10px',
                        }}
                    >

                        <h5 className="border-bottom pb-2 mb-3">Upload:</h5>
                        <div className="container py-5">


                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Select Documents:</label>
                                    <input type="file" multiple className="form-control" onChange={handleFileChange} required />
                                </div>

                                <button type="submit" className="btn btn-primary">Upload</button>
                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={() => {
                                        localStorage.removeItem("bookingData");
                                        navigate("/success", { state: { uploaded: false } });
                                    }}
                                >
                                    Skip
                                </button>
                            </form>
                        </div>

                    </div>
                </div>
                <div className="space60"></div>
                <div className="space40"></div>
            </div>

        </div >
    );
};

export default UploadDocumentsPage;


